<template>
  <div>
      <h4 class="text-right mb-1">
        {{ dataField.title ? dataField.title : "" }}
      </h4>
    <div class="pelak motor" v-if="dataField.params.type == 'motor'">
      <div class="flag">
        <img src="/img/components/pelak_flag_car.png" />
        <input
          data-index="0"
          ref="input-0"
          @input="focusNextOncePopulated($event, 3)"
          placeholder="123"
        />
      </div>
      <div class="main">
        <input
          data-index="1"
          ref="input-1"
          @input="focusNextOncePopulated($event, 5)"
          placeholder="56789"
          maxlength="5"
        />
      </div>
    </div>
    <div class="pelak car" v-else-if="dataField.params.type != 'motor'">
      <div class="main">
        <img src="/img/components/pelak_flag_car.png" />
        <input
          data-index="2"
          ref="input-2"
          @input="focusNextOncePopulated($event, 2)"
          placeholder="12"
        />
        <input
          data-index="3"
          ref="input-3"
          @input="focusNextOncePopulated($event, 1)"
          placeholder="ب"
        />
        <input
          data-index="4"
          ref="input-4"
          @input="focusNextOncePopulated($event, 3)"
          placeholder="345"
        />
      </div>
      <div class="city">
        <input
          data-index="5"
          ref="input-5"
          @input="focusNextOncePopulated($event, 2)"
          placeholder="10"
          maxlength="2"
        />
      </div>
    </div>
      <v-alert type="error" v-if="alerts[dataField.name] != null">{{alerts[dataField.name]}}</v-alert>
  </div>
</template>

<script>
export default {
  name: "IranPelakBox",
  props: ["dataField"],
  computed: {
    dataPost: {
      get() {
        this.$store.commit("updateDataPost", this.$store.state.dataPost);
        return this.$store.state.dataPost;
      },
    },
    alerts: {
      get() {
        return this.$store.state.alerts;
      },
    },
  },
  data: () => ({
    required: [(v) => !!v || "اجباری می باشد"],
    value: "",
  }),
  methods: {
    focusNextOncePopulated(event, max) {
      //set value
      let tmpVal = "";
      for (var i = 0; i <= 5; i++) {
        if (this.$refs["input-" + i])
          tmpVal += "-" + this.$refs["input-" + i].value;
      }
      this.value = tmpVal;
      this.$store.commit("updateDataPostByIndex", {
        index: this.dataField.name,
        val: this.value,
      });

      if (event.target.value.length === max) {
        const nextElement = this.$refs?.[
          `input-${Number(event.target.dataset.index) + 1}`
        ];
        if (nextElement) {
          nextElement.focus();
          this.value += event.target.value;
        }
      }
    },
  },
};
</script>
<style>
.pelak {
  border-radius: 3px;
  border: 4px solid #4d4d4d;
  margin: 20px 0;
}
.pelak input {
  background: transparent;
  font-size: 1.7rem;
  text-align: center;
}
/* car css */
.pelak.car {
  width: 100%;
  height: 8vh;
}
.pelak.car .city {
  float: right;
  width: 30%;
  border-left: 3px solid #4d4d4d;
  height: 7vh;
}
.pelak.car .city input {
  height: 100%;
  float: left;
  width: 100%;
}
.pelak.car .main {
  width: 70%;
  float: left;
}
.pelak.car .main img {
  height: 7vh;
  float: left;
}
.pelak.car .main input {
  height: 7vh;
  float: left;
  width: 28%;
}

/* motor css */
.pelak.motor {
  width: 100%;
  height: 16vh;
}
.pelak.motor .flag img {
  height: 8vh;
  float: left;
}
.pelak.motor .main {
  height: 8vh;
  float: left;
  width: 100%;
}
.pelak.motor input {
  height: 100%;
  float: right;
  width: 85%;
}
</style>
